import cx from 'classnames';
import styles from './CartLink.scss';

import React, { createRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useCart } from 'src/components/Cart/UseCart';
import { LocaleLink } from 'src/components/ContentLink/LocaleLink';
import { useFeatureFlagsContext } from 'src/components/FeatureFlags/FeatureFlags';
import { Image } from 'src/components/Image/Image';
import { useNavBarContext } from 'src/components/NavBarContext/NavBarContext';
import { TrackedLink } from 'src/components/TrackedLink/TrackedLink';
import { redesignV2RoutePath } from 'src/constants/redesignV2';
import cartIcon from 'src/images/icons/cart-icon.svg';
import { Environment } from 'src/utils/Environment';
import { stringFormatForTestAttr } from 'src/utils/StringFormatForTest';

export const OLD_CART_URL = '/shop/cart';

export const CartLink: React.FC = () => {
  const ref = createRef<HTMLAnchorElement>();
  const { t } = useTranslation();
  const isCloverMerchant = Environment.current.isExistingMerchant;
  const { hideCartIcon } = useNavBarContext();
  const { checkout } = useCart();
  const itemsInCart = checkout.count;

  const { isFlagEnabled } = useFeatureFlagsContext();
  const isDotcomCartEnabled = isFlagEnabled('use-dotcom-cart');

  if (isCloverMerchant || hideCartIcon) return null;

  const props = {
    'className': styles.cartLink,
    'title': t('your-cart'),
    'aria-label': t('navigation-header.cart'),
    'data-test': `${stringFormatForTestAttr(t('navigation-header.cart'))}`,
  };

  const icon = (
    <>
      <Image src={cartIcon} className={styles.cartLinkIcon} alt={t('cart')} />
      {itemsInCart > 0 && <span className={cx(styles.cartLinkBubble, { [styles.cartLinkBubbleDouble]: itemsInCart > 9 })}>{itemsInCart}</span>}
    </>
  );

  if (!isDotcomCartEnabled) return <TrackedLink href={OLD_CART_URL} {...props}>{icon}</TrackedLink>;

  return <LocaleLink innerRef={ref} to={redesignV2RoutePath.CART} {...props}>{icon}</LocaleLink>;
};
